import Home from "../components/home/Home";
import Layout from "../layout/Layout";

const HomePage = () => {
  return (
    <Layout>
      <Home />
    </Layout>
  );
};

export default HomePage;
